<template>
  <div>
    <div class="container">
      <div class="infoContain">
        <div>
          <div class="flex jus-stt" style="margin-left: 10px;">
            <h3>기본 정보</h3>
          </div>
          <ValidationObserver v-slot="{ handleSubmit }">
            <form
              class="infoBoxForm"
              @submit.prevent="handleSubmit(onClickNextBtn)"
            >
              <div class="flex mobileFlex wd100">
                <div class="profileImgBox wd50">
                  <div class="profileImgInputBox preview-image">
                    <input
                      class="upload-name"
                      disabled="disabled"
                      :style="`background-image:url(${imageUrl});`"
                    />
                    <label for="input-file"></label>
                    <input
                      type="file"
                      id="input-file"
                      class="upload-hidden"
                      @change="setFileImage"
                    />
                  </div>
                </div>
                <div class="flex flex-col wd50">
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="아이디"
                    rules="required|id"
                    v-slot="{ errors }"
                  >
                    <label>아이디<span class="labelItem">*</span></label>
                    <input v-model="signupInfo.id" maxlength="20" />
                    <input
                      type="button"
                      value="중복확인"
                      @click="onClickConfirmId"
                      :disabled="errors[0] != null"
                    />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="비밀번호"
                    rules="required|pw"
                    vid="비밀번호"
                    v-slot="{ errors }"
                  >
                    <label
                      >비밀번호<span class="labelItem">*</span>(특수문자 포함,
                      8자리 이상)</label
                    >
                    <input
                      type="password"
                      v-model="signupInfo.password"
                      maxlength="16"
                      autocomplete="new-password"
                    />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="비밀번호 재확인"
                    rules="required|confirmed:@비밀번호"
                    vid="비밀번호 재확인"
                    v-slot="{ errors }"
                  >
                    <label
                      >비밀번호 확인<span class="labelItem">*</span>(한번 더
                      입력해주세요.)</label
                    >
                    <input
                      type="password"
                      v-model="confirmedPassword"
                      maxlength="16"
                    />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="담당자"
                    rules="required|name"
                    v-slot="{ errors }"
                  >
                    <label>담당자<span class="labelItem">*</span></label>
                    <input v-model="signupInfo.name" maxlength="16" />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="flex mobileFlex">
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="이메일"
                  rules="required|email"
                  v-slot="{ errors }"
                >
                  <label>이메일<span class="labelItem">*</span></label>
                  <input v-model="signupInfo.email" />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="담당자 휴대폰 번호"
                  rules="required|mobileTel"
                  v-slot="{ errors, valid }"
                >
                  <label
                    >담당자 휴대폰 번호<span class="labelItem">*</span></label
                  >
                  <input
                    v-model="signupInfo.phoneNumber"
                    @keypress="eventUtil.onKeyPressForOnlyDigit($event)"
                  />
                  <input
                    type="button"
                    value="인증번호 받기"
                    @click="onClickRequestVerifyNumber(valid)"
                  />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="flex mobileFlex">
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="기업명"
                  rules="required|corpName"
                  v-slot="{ errors }"
                >
                  <label>기업명<span class="labelItem">*</span></label>
                  <input v-model="signupInfo.companyName" maxlength="42" />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="인증번호"
                  rules="required|verifyNum"
                  v-slot="{ errors, valid }"
                >
                  <label>인증번호 6자리 입력 </label>
                  <input
                    v-model="verifyNumber"
                    maxlength="6"
                    @keypress="eventUtil.onKeyPressForOnlyDigit($event)"
                    :placeholder="counterPlaceHolder"
                  />
                  <input
                    type="button"
                    value="확인"
                    @click="onClickConfirmVerifyNumber(valid)"
                    :disabled="counter == 0"
                  />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                  <vac
                    ref="verifyNumberCounter"
                    :autoStart="false"
                    :end-time="new Date().getTime() + 180000"
                  >
                    <template v-slot:process="{ timeObj }">
                      {{ onProcesssVerifyNumberCounter(timeObj) }}
                    </template>
                    <template v-slot:finish>
                      {{ onFinishVerifyNumberCounter() }}
                    </template>
                  </vac>
                </ValidationProvider>
              </div>
              <div class="flex mobileFlex">
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="대표 번호"
                  v-slot="{ errors }"
                >
                  <label>대표 번호</label>
                  <input
                    v-model="signupInfo.representativeNumber"
                    @keypress="eventUtil.onKeyPressForOnlyDigit($event)"
                  />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="설립연도"
                  rules="required|year"
                  v-slot="{ errors }"
                >
                  <label>설립일<span class="labelItem">*</span></label>
                  <input
                    v-model="signupInfo.establishmentYear"
                    maxlength="4"
                    placeholder="YYYY"
                  />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="flex mobileFlex">
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="매출 규모"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label>매출 규모<span class="labelItem">*</span></label>
                  <input v-model="signupInfo.profitSize" maxlength="21" />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="사원수"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label>사원수<span class="labelItem">*</span></label>
                  <input
                    v-model="signupInfo.memberSize"
                    @keypress="eventUtil.onKeyPressForOnlyDigit($event)"
                    maxlength="21"
                  />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="flex mobileFlex">
                <div class="inputBox infoBox wd100">
                  <label>홈페이지</label>
                  <input v-model="signupInfo.homePage" maxlength="85" />
                </div>
              </div>
              <div class="flex mobileFlex">
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="업종"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label>업종<span class="labelItem">*</span></label>
                  <div class="bspSelectBox">
                    <b-form-select
                      v-model="signupInfo.fieldType"
                      :options="fieldTypeOptions"
                    ></b-form-select>
                  </div>
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="기업 형태"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label>기업형태<span class="labelItem">*</span></label>
                  <div class="bspSelectBox">
                    <b-form-select
                      v-model="signupInfo.companyType"
                      :options="companyTypeOptions"
                    ></b-form-select>
                  </div>
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="flex mobileFlex">
                <ValidationProvider
                  class="inputBox infoBox wd100 addressPosition"
                  name="주소"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label>주소<span class="labelItem">*</span></label>
                  <input v-model="addr1" readonly />
                  <input
                    type="button"
                    value="우편번호 찾기"
                    @click="onClickSearchAdderss"
                  />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="flex mobileFlex">
                <ValidationProvider
                  class="inputBox infoBox wd100 addressPosition"
                  name="상세주소"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label>상세주소<span class="labelItem">*</span></label>
                  <input v-model="signupInfo.addressDetail" />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="btnBox flex topPd">
                <button
                  type="button"
                  class="btnFont redborderBtn"
                  @click="onClickBeforeBtn"
                >
                  이 전
                </button>
                <button type="submit" class="btnFont redBtn">다 음</button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapMutations, mapActions } from "vuex";
import * as eventUtil from "@/utils/eventUtil";
import * as addressFind from "@/utils/addressFind";
import * as corpUtil from "@/utils/corpUtil";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      eventUtil: eventUtil,
      signupInfo: {},
      checkedId: "", // 중복검사 완료된 아이디
      checkedPhoneNumber: "", // 인증을 요청한 전화번호
      confirmedPassword: "", // 비밀번호 재확인 값
      isVerified: false, // 전화번호 인증 여부
      verifyNumber: "", // 인증번호
      counter: 0, // 인증번호 유효 시간 카운터
      counterPlaceHolder: "", // 인증번호 유효 시간 카운터(출력용)
      addr1: "", // addressFind util 주소검색 결과
      postcode: "", // addressFind util 주소검색 결과(우편번호)
      fieldTypeOptions: corpUtil.fieldType,
      companyTypeOptions: corpUtil.companyType,
      imageUrl: require("@/assets/images/user/camera-icon.png"),
      file: null,
    };
  },
  computed: {},
  methods: {
    ...mapMutations("join", ["setCurrentTab", "setSignupForm"]),
    ...mapActions("auth", ["isAlreadyExistUsername"]),
    ...mapActions("sms", ["requestVerifyNumber", "confirmVerifyNumber"]),
    onClickConfirmId() {
      if (!this.signupInfo.id) {
        this.$alert("알림", "아이디를 입력해주세요.");
        return false;
      }

      this.isAlreadyExistUsername(this.signupInfo.id)
        .then((response) => {
          const data = response.data;

          var requestId = data.REQUEST_USERNAME;
          var result = data.RESULT;

          if (result == true) {
            this.checkedId = "";
            this.$alert("알림", "이미 존재하는 아이디 입니다.");
          } else {
            this.checkedId = requestId;
            this.$alert("알림", "사용 가능한 아이디 입니다.");
          }
        })
        .catch(() => {
          this.checkedId = "";
        });
    },
    onClickRequestVerifyNumber(isValidPhoneNumber) {
      if (!isValidPhoneNumber || this.signupInfo.phoneNumber === "") {
        this.$alert("알림", "휴대폰번호를 확인해주세요.");
        return;
      }

      const phoneNumber = this.signupInfo.phoneNumber;
      this.isVerified = false;
      console.log("phoneNumber : " + phoneNumber)
      this.requestVerifyNumber({
        phoneNumber: phoneNumber,
        contents: "[경희대학교 AgeTech Platform] 회원가입 전화번호 인증",
      })
        .then((response) => {
          const data = response.data;

          if (data.RESULT == "true") {
            this.checkedPhoneNumber = phoneNumber; // 인증번호를 요청한 전화번호 저장
            this.$refs.verifyNumberCounter.startCountdown("restart");
            this.$alert(
              "알림",
              "인증번호를 발송했습니다.(유효시간 3분) <br>" +
                "인증번호가 오지 않으면 입력하신 정보가 정확한지 확인하여 주세요.<br>" +
                "이미 가입된 번호이거나, 가상전화번호는 인증번호를 받을 수 없습니다."
            );
          } else {
            this.checkedPhoneNumber = ""; // 인증번호를 요청한 전화번호 초기화
            this.$refs.verifyNumberCounter.finishCountdown();
            if (
              data.ERROR_CODE == "SUCCESSIVE_REQUEST" ||
              data.ERROR_CODE == "BLOCKED"
            ) {
              this.$alert("알림", "5분 뒤에 다시 시도해주세요.");
            } else {
              this.$alert("알림", "인증번호 요청을 실패했습니다.");
            }
          }
        })
        .catch(() => {
          this.checkedPhoneNumber = ""; // 인증번호를 요청한 전화번호 초기화
          this.$refs.verifyNumberCounter.finishCountdown();
          this.$alert("알림", "인증번호 요청을 실패했습니다.");
        });
    },
    onClickConfirmVerifyNumber(isValidVerifyNumber) {
      if (!isValidVerifyNumber || this.verifyNumber === "") {
        return;
      }

      this.confirmVerifyNumber({
        phoneNumber: this.checkedPhoneNumber,
        verifyNum: this.verifyNumber,
      })
        .then((response) => {
          const data = response.data;

          if (data.RESULT == "true") {
            this.isVerified = true;
            this.$refs.verifyNumberCounter.finishCountdown();
            this.$alert("알림", "인증되었습니다.");
          } else {
            this.isVerified = false;
            this.$alert("알림", "유효하지 않은 인증번호 입니다.");
          }
        })
        .catch(() => {
          this.isVerified = false;
          this.$alert("알림", "요청 실패");
        });
    },
    onProcesssVerifyNumberCounter(timeObj) {
      this.counter = timeObj.m * 60 + timeObj.s;
      this.counterPlaceHolder = `${timeObj.m}:${timeObj.s}`;
    },
    onFinishVerifyNumberCounter() {
      this.counter = 0;
      this.counterPlaceHolder = "";
    },
    onClickSearchAdderss() {
      addressFind.FindAddress(this);
    },
    onClickBeforeBtn() {
      this.signupInfo = {};
      this.checkedId = "";
      this.checkedPhoneNumber = "";
      this.confirmedPassword = "";
      this.isVerified = false;
      this.verifyNumber = "";
      this.counter = 0;
      this.counterPlaceHolder = "";
      this.addr1 = "";
      this.postcode = "";

      this.setCurrentTab(1);
    },
    onClickNextBtn() {
      if (!(this.signupInfo.id === this.checkedId)) {
        this.$alert("알림", "아이디 중복확인을 해주세요.");
        return;
      }
      if (!(this.signupInfo.password === this.confirmedPassword)) {
        this.$alert("알림", "비밀번호가 일치하지 않습니다.");
        return;
      }

      // if (!(this.isVerified && this.signupInfo.phone === this.checkedPhoneNumber)) {
      //   this.$alert('알림', '전화번호를 인증해주세요.')
      //   return
      // }

      // addressFind util에서 가져온 주소 데이터를 저장
      this.signupInfo.address = this.addr1;

      const signupInfo = this.signupInfo;
      this.setSignupForm(signupInfo);
      this.setCurrentTab(3);
    },
    setFileImage(event) {
      let file = event.target.files[0];
      let fileName = event.target.files[0].name;

      let fileNameArr = fileName.split(".");
      let ext = fileNameArr[fileNameArr.length - 1];

      let checkExts = [
        "gif",
        "png",
        "jpg",
        "jpeg",
        "GIF",
        "PNG",
        "JPG",
        "JPEG",
      ];

      let check = checkExts.some(function(checkExt) {
        return ext === checkExt;
      });

      if (!check) {
        this.$alert(
          "알림",
          "업로드가 불가한 확장자입니다. <br>(gif, png, jpg, jpeg 파일만 업로드할 수 있습니다.)"
        );
        return;
      }

      if (file.size >= 1024 * 1024 * 10) {
        this.$alert("알림", "첨부파일은 10mb이하의 크기만 업로드 가능합니다.");
        return;
      }

      this.file = file;
      this.imageUrl = URL.createObjectURL(this.file);
    },
  },
};
</script>

<style scoped lang="scss">
.checkBoxForm ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
  @import "~bootstrap-vue/dist/bootstrap-vue.min";
}
.bspRadio ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
}
.bspSelectBox ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
  @import "~bootstrap-vue/dist/bootstrap-vue.min";
}
</style>

<style scoped>
input:disabled {
  color: #7d7d7d;
}
.profileImgBox {
  padding: 0 1rem;
  /* padding: 40px 0; */
  text-align: center;
}
.profileImgInputBox {
  position: relative;
  width: 100%;
  height: 96%;
}
.profileImgInputBox input[type="file"] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.profileImgInputBox label:active {
  transform: scale(0.97);
}
.profileImgInputBox label {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: transparent;
  cursor: pointer;
  left: 0;
  margin-left: 0px;
  top: 0;
}
.profileImgInputBox .upload-name {
  border: 0;
  display: flex;
  width: 100%;
  height: 100%;
  padding: 6px 20px 5px; /* label의 패딩값과 일치 */
  font-size: inherit;
  font-family: inherit;
  line-height: normal;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-size: 80%;
  background-position: center;
  /* background-image: url('../../../assets/images/user/imgEnroll.png'); */
  -webkit-appearance: none; /* 네이티브 외형 감추기 */
  -moz-appearance: none;
  appearance: none;
}
/* preview img */
.filebox .upload-display {
  /* 이미지가 표시될 지역 */
  margin-bottom: 5px;
}
@media (min-width: 768px) {
  .filebox .upload-display {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 0;
  }
}
.filebox .upload-thumb-wrap {
  /* 추가될 이미지를 감싸는 요소 */
  display: inline-block;
  width: 54px;
  padding: 2px;
  vertical-align: middle;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fff;
}
.filebox .upload-display img {
  /* 추가될 이미지 */
  display: block;
  max-width: 100%;
  width: 100% \9;
  height: auto;
}
</style>
